import type { OtterfolioPosition } from "../../lib/otterfolio";
import { RenditebrueckeBadge } from "./RenditebrueckeBadge";
import { OTTERFOLIO_THEME } from "./theme";

function fmtEur(cents: number): string {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
}

function fmtPct(percent: number, digits = 1): string {
  const sign = percent >= 0 ? "+" : "";
  return `${sign}${percent.toFixed(digits)} %`;
}

interface Props {
  position: OtterfolioPosition;
}

export function CompactPositionTile({ position }: Props) {
  const perfPositive = position.returnPercent >= 0;
  const perfColor = perfPositive ? OTTERFOLIO_THEME.primary : OTTERFOLIO_THEME.highlight;

  return (
    <div
      style={{
        background: OTTERFOLIO_THEME.cardBg,
        border: `1px solid ${OTTERFOLIO_THEME.cardBorder}`,
        borderRadius: 8,
        padding: 8,
        color: OTTERFOLIO_THEME.text,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        minWidth: 0,
      }}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: 12,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {position.name}
      </div>
      <div style={{ fontSize: 15, fontWeight: 700, marginTop: 2 }}>{fmtEur(position.valueCents)}</div>
      <div style={{ fontSize: 11, fontWeight: 700, color: perfColor }}>
        {fmtPct(position.returnPercent * 100)}
      </div>
      <div style={{ fontSize: 10, color: OTTERFOLIO_THEME.textMuted, marginTop: 2 }}>
        Ø {fmtEur(position.avgCostCents)} · {fmtEur(position.currentPriceCents)}
      </div>
      <div style={{ marginTop: 4 }}>
        <RenditebrueckeBadge rb={position.renditebruecke} />
      </div>
    </div>
  );
}
